<template>
    <div class="income-popup daily"  v-on:mouseup="EndDrag()" v-bind:style="{top: posy + 'px', left: posx + 'px', display: toggled ? 'inline-block' : 'none'}">
        <div class="background" v-on:click="Close()"></div>
        <div class="pointer" v-bind:class="[pointerDirection]" v-bind:style="{left: pointerOffsetX, top: pointerOffsetY}"></div>
        <div class="header">
            <div class="label"></div>
        </div>
        <div class="fa-stack cancel" v-on:click="Toggle(false)">
            <i class="fas fa-circle fa-stack-2x"></i>
            <i class="fas fa-times fa-stack-2x"></i>
        </div>
        <div class="entry header">
            <div class="fa-stack left" v-on:click="ChangeDate(date.clone().add(-1,'days'))">
                <i class="fas fa-circle fa-stack-2x"></i>
                <i class="fas fa-angle-left fa-stack-2x"></i>
            </div>
            <div class="fa-stack right" v-on:click="ChangeDate(date.clone().add(1,'days'))">
                <i class="fas fa-circle fa-stack-2x"></i>
                <i class="fas fa-angle-right fa-stack-2x"></i>
            </div>
            <div class="label bold">{{date.format('dddd')}},</div>
            <div class="label">{{date.format('DD')}}. {{date.format('MMMM YYYY')}}</div>
        </div>
        <div class="entry timeframe">
            <div class="line-through"></div>
            <div class="label" v-if="isPlanned">Planned</div>
            <div class="label" v-if="!isPlanned">Unplanned</div>
        </div>
        <div class="entry icon">
            <div class="label">{{income}}</div>
        </div>
        <div class="entry timeframe">
            <div class="line-through"></div>
        </div>
        <div class="entry icon daily">
            <div class="grid">
                <div class="line" v-for="indexLine in 20" :key="indexLine + 'line'"></div>
                <div class="bar" v-for="(bar, indexBar) in dailyBars" v-on:mouseover="ShowBarAmount(bar.entry)"v-on:mouseleave="HideBarAmount(bar.entry)" :key="indexBar + 'bar'" v-bind:class="bar.classes" v-bind:style="{height: bar.length}">
                    <div class="handle" v-on:mousedown="StartDrag(bar)">
                    </div>
                </div>
                <div class="label bottom">24 Stunden</div>
                <div class="label left">Umsätze</div>
                <div class="amount"></div>
                <div class="background" v-on:click="selectionMenu = []" style="z-index: 1" v-if="selectionMenu.length > 0"></div>
                <div class="amount selection" v-if="selectionMenu.length > 0">
                    <div class="label" v-for="(selection, indexSelection) in selectionMenu" :key="indexSelection" v-on:click="selection.callbackSelection(selection.item)">{{selection.label}}</div>
                </div>
            </div>
        </div>
        <div class="entry nav">
            <div class="line-through"></div>
            <div class="fa-stack left" v-on:click="ToggleDaily()">
                <i class="fas fa-circle fa-stack-2x"></i>
                <i class="fas fa-angle-left fa-stack-2x"></i>
            </div>
            <div class="fa-stack right" v-on:click="ToggleDaily()">
                <i class="fas fa-circle fa-stack-2x"></i>
                <i class="fas fa-angle-right fa-stack-2x"></i>
            </div>
        </div>
        <div class="entry income-list">
            <div class="scrollbar-container">
                <div class="entry input">
                    <div class="circle gray"></div>
                    <input min="0" max="24" v-model="saleNewFromHour" type="number" class="label timeframe"/>
                    <div class="label hour">:</div>
                    <input min="0" max="59" v-model="saleNewFromMinutes" type="number" class="label timeframe"/>
                    <div class="label divider">-</div>
                    <input min="0" max="24" v-model="saleNewToHour" type="number" class="label timeframe"/>
                    <div class="label hour">:</div>
                    <input min="0" max="59" v-model="saleNewToMinutes" type="number" class="label timeframe"/>
                    <div class="label">€ </div>
                    <input v-model="saleNew" v-on:keydown="UpdateTimeFrame($event)"  type="number" class="label"/>
                    <div class="label">-</div>
                    <div class="fa-stack" v-on:click="AddNewSale()">
                        <i class="fas fa-circle fa-stack-2x"></i>
                        <i class="fas fa-plus fa-stack-2x"></i>
                    </div>
                </div>
                <div class="entry" v-for="(entry, index) in itemsFiltered" v-bind:class="[entry.classes]" :key="index">
                    <div class="circle" v-bind:class="entry.color"></div>
                    <div class="label timeframe">{{entry.fromDate.format('HH:mm') + ' - ' + entry.toDate.format('HH:mm')}}</div>
                    <div class="label">€ </div>
                    <input v-model="entry.income" v-on:keydown="UpdateTimeFrame($event, entry)" v-on:blur="UpdateTimeFrame($event, entry)" type="number" class="label" v-bind:style="{width: (10 + (entry.income.length * 9)) + 'px'}"/>
                    <div class="label">-</div>
                    <div class="fa-stack" v-on:click="RemoveSale(entry)">
                        <i class="fas fa-circle fa-stack-2x"></i>
                        <i class="fas fa-times fa-stack-2x"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'incomepopup',
        components: {
        },
        data(){
            return{
                toggled: false,
                posxstart: 0,
                posystart: 0,
                posx: 0,
                posy: 0,
                width: 0,
                height: 0,
                appendedData: {},
                pointerDirection: 'top',
                elRelative: null,
                date: moment(),
                income: '€ -',
                isHourly: false,
                isPlanned: false,
                itemsFiltered: [
                ],
                pointerOffsetX: '',
                pointerOffsetY: '',
                dailyBars: [],
                mouse: {x: 0, y: 0},
                barDragging: null,
                gridPixelRatio: 0,
                dragStart: {x: 0, y: 0},
                rawData: [],
                saleNew: '0',
                saleNewFromHour: '00',
                saleNewFromMinutes: '00',
                saleNewToHour: '00',
                saleNewToMinutes: '15',
                selectionMenu: [],
                averageIncomeRatio: 0,
                startDragIncome: 0,
            }
        },
        created () {
            var view = this;
            this.toggled = false;
            window.addEventListener('resize', this.Reposition);
        },

        mounted () {
            var view = this;
        },

        update(){
        },
        watch:{
            saleNewFromHour: function (newVal, oldVal){
                if(parseInt(newVal) < 10 && newVal.length === 1) this.saleNewFromHour = '0' + newVal;
                if(this.saleNewFromHour.length > 2) this.saleNewFromHour = this.saleNewFromHour[1] + this.saleNewFromHour[2];
                if(parseInt(this.saleNewFromHour) > 23) this.saleNewFromHour = '23';
                if(parseInt(this.saleNewFromHour) < 0) this.saleNewFromHour = '00';
                if(parseInt(this.saleNewToHour) < parseInt(this.saleNewFromHour)) this.saleNewToHour = this.saleNewFromHour;
            },
            saleNewToHour: function (newVal, oldVal){
                if(parseInt(newVal) < 10 && newVal.length === 1) this.saleNewToHour = '0' + newVal;
                if(this.saleNewToHour.length > 2) this.saleNewToHour = this.saleNewToHour[1] + this.saleNewToHour[2];
                if(parseInt(this.saleNewToHour) > 23) this.saleNewToHour = '23';
                if(parseInt(this.saleNewToHour) < 0) this.saleNewToHour = '00';
                if(parseInt(this.saleNewToHour) < parseInt(this.saleNewFromHour)) this.saleNewToHour = this.saleNewFromHour;
            }
        },

        beforeDestroyed(){
            this.$el.removeEventListener('mousemove', this.TrackMouse);
        },
        destroyed(){
            window.removeEventListener('resize', this.Reposition);
        },
        methods: {
            RemoveSale(sale){
                this.DeleteSale (sale.saleData);
            },
            AddNewSale(){
                var view = this;
                if(parseInt(this.saleNew) === 0) return;
                var fromDate = this.date.clone().hours(parseInt(this.saleNewFromHour)).minutes(parseInt(this.saleNewFromMinutes));
                var toDate = this.date.clone().hours(parseInt(this.saleNewToHour)).minutes(parseInt(this.saleNewToMinutes));
                var sale = {planned: this.isPlanned, date: fromDate.clone(), fromDate: fromDate, toDate: toDate, color: 'red', income: parseFloat(this.saleNew), amount: parseFloat(this.saleNew) * 100};
                sale.from = sale.fromDate.format('YYYY-MM-DDTHH:mm');
                sale.to = sale.toDate.format('YYYY-MM-DDTHH:mm');
                sale.itemCount = 1;
                sale.description = '';
                this.CreateStoreSale(sale);
            },
            UpdateTimeFrame($event, entry){
                var view = this;
                var target = $event.currentTarget;
                var type = $event.type;
                requestAnimationFrame(function(){
                    target.value = parseInt(target.value);
                    if(type === "blur") {
                            if(entry) {
                                entry.saleData.amount = target.value * 100;
                                view.EditStoreSale(entry.saleData);
                            }
                        }
                    });
                this.RefreshListInputs();
            },
            TrackMouse($event){
                this.mouse.x = $event.clientX;
                this.mouse.y = $event.clientY;

                $('.grid .amount:not(.selection)').css({top: $event.clientY + 'px', left: $event.clientX + 'px'});
                if(this.barDragging != null){
                    this.RecalculateBarsLength();
                    var percent = ($('.income-popup .grid')[0].getBoundingClientRect().bottom - this.mouse.y) / $('.income-popup .grid').height();
                    var amount = (percent * this.averageIncomeRatio * 100).toFixed(2);
                    if(amount < 0) amount = 0;
                    amount = Math.floor(amount / 10) * 10;
                    this.barDragging.entry.label = this.barDragging.label = '€ ';
                    this.barDragging.entry.label = this.barDragging.label += amount;
                    this.barDragging.entry.income = amount;
                    this.barDragging.entry.label = this.barDragging.label += '-';
                    if(percent < 0) percent = .001;
                    if(percent > .9)
                    {
                        percent = .9;
                        this.gridPixelRatio *= .9;
                    }
                    var length = this.CalculateLength(percent * 100);
                    this.barDragging.length = length + '%';
                    $(this.$el).find('.grid .amount:not(.selection)').text(this.barDragging.entry.label);
                    $(this.$el).find('.grid .amount:not(.selection)').css({opacity: 1});
                }

            },
            CalculateLength(length){
                if(length > 100) length = 100;
                else if(length <= 0) length = 0;
                else if(length < 5) length = 5;
                else if(length < 25) length = 25;
                else if(length < 50) length = 50;
                else if(length < 75) length = 75;
                else if(length < 100) length = 95;
                return length;
            },
            RecalculateBarsLength(){
            return;
                var view = this;
                if(!this.dailyBars.find(b => (view.gridPixelRatio * parseFloat(b.income)) > 50)) this.gridPixelRatio *= 1.1;
                this.dailyBars.forEach(b => {
                    //var percent = ($('.income-popup .grid')[0].getBoundingClientRect().bottom) / $('.income-popup .grid').height();

                    var length = view.CalculateLength(view.gridPixelRatio * parseFloat(b.income));
                    b.length =  length + '%';
                });
            },
            StartDrag(bar){
                this.barDragging = bar;
                this.dragStart = {x: this.mouse.x, y: this.mouse.y};
                this.startDragIncome = bar.entry.income;
            },
            EndDrag(){

                if(this.barDragging === null) return;
                var view = this;
                var barDragging = this.barDragging;
                var options = view.rawData.filter(d => barDragging.entry.planned == d.planned && d.date.hours() === view.barDragging.entry.date.hours());
                if(options.length > 0)
                {
                    var totalFromHour = 0;
                    options.forEach(d => totalFromHour += d.amount);
                    $(this.$el).find('.grid .amount.selection').css({opacity: 1});
                    this.selectionMenu = [];
                    options.forEach(o => {
                        view.selectionMenu.push({planned: barDragging.entry.planned, label: o.fromDate.format('HH:mm') + ' -' + o.toDate.format('HH:mm'), item: o, callbackSelection: function(item){
                            o.amount = barDragging.entry.income * 100;
                            view.EditStoreSale(o);
                            view.selectionMenu = [];
                        }});
                    });
                    if(barDragging.entry.income * 100 > totalFromHour)
                    {
                        view.selectionMenu.push({planned: barDragging.entry.planned, label: 'New', item: {planned: view.isPlanned, date: barDragging.entry.date.clone(), fromDate: barDragging.entry.date.clone(), toDate: barDragging.entry.date.clone().add(1, 'hours'), color: 'red', income: barDragging.entry.income}, callbackSelection: function(item){
                            item.from = item.fromDate.format('YYYY-MM-DDTHH:mm');
                            item.to = item.toDate.format('YYYY-MM-DDTHH:mm');
                            var total = 0;
                            view.rawData.forEach(d => total += (d.planned === view.isPlanned && d.date.hours() === barDragging.entry.date.hours()) ? d.amount : 0);
                            item.amount = (item.income * 100) - total;
                            //view.itemsFiltered.push(item);
                            view.CreateStoreSale(item);
                            view.selectionMenu = [];
                        }});
                    }
                } else {

                    var averageTotal = 0;
                    view.rawData.forEach(d => {
                        averageTotal += view.isPlanned ? (d.planned ? d.amount : 0) : (!d.planned ? d.amount :0);
                    });
                    var items = view.rawData.filter(d => view.isPlanned == d.planned);
                    var totalHour = 0;

                    items.forEach(d => {
                        totalHour += d.amount
                    });
                    var classes = [];
                    if (totalHour < averageTotal * .3) classes.push('red');
                    else if(totalHour < averageTotal) classes.push('orange');
                    else if (totalHour > averageTotal * .5) classes.push('green');
                    var income = '€ ';
                    income += (totalHour * .01);
                    income += '-';
                    var color = !this.isPlanned ? classes[0] : 'gray';
                    var item = {description: '', itemCount: 1, planned: barDragging.entry.planned, label: income, saleData: view.barDragging.entry, income: view.barDragging.entry.income, color: color, fromDate: view.barDragging.entry.date.clone(), date: view.barDragging.entry.date.clone(), toDate:  view.barDragging.entry.date.clone().add(1, 'hours')};
                    item.from = item.fromDate.format('YYYY-MM-DDTHH:mm');
                    item.to = item.toDate.format('YYYY-MM-DDTHH:mm');
                    item.amount = item.income * 100;
                    view.CreateStoreSale(item);


                }
                this.barDragging = null;
            },
            ShowBarAmount(entry){
                $(this.$el).find('.grid .amount:not(.selection)').text(entry.label);
                $(this.$el).find('.grid .amount:not(.selection)').css({opacity: 1});
            },
            HideBarAmount(){
                $(this.$el).find('.grid .amount:not(.selection)').text('');
                $(this.$el).find('.grid .amount:not(.selection)').css({opacity: 0});
            },
            Close(){
                this.Toggle(false);
            },
            ToggleDaily(){
            
                this.isPlanned = !this.isPlanned;
                this.InitData(this.isPlanned);
            },
            Toggle(val){
                if(val !== undefined || val !== null) {
                    if(!val) this.selected = null;
                    this.toggled = val;
                    return;
                }
                this.toggled = !this.toggled;
                if(!this.toggled) this.selected = null;
            },
            Reposition(){
                var view = this;
                requestAnimationFrame(function(){
                    if(!view.elRelative) return;
                    var box = view.elRelative.getBoundingClientRect();
                    var widthTotal = window.innerWidth;
                    var heightTotal = window.innerHeight;
                    var posx = 0;
                    var posy = 0;
                    var userselectwidth = 400;
                    var userselectheight = 520;
                    var offsety = 20;
                    var offsetyBottom = 70;
                    view.pointerOffsetX = '';
                    if(widthTotal - (box.left + (box.width / 2)) > (userselectwidth / 2)) {
                        posx = (box.left + (box.width / 2)) - (userselectwidth / 2);
                    } else {
                        requestAnimationFrame(function(){
                            var popupBox = view.$el.getBoundingClientRect();
                            var pointerBox = $(view.$el).find('.pointer')[0].getBoundingClientRect();
                            var pointerOffsetX = (((box.left + (box.width / 2)) - ((popupBox.left + popupBox.right) / 2)) / .4);
                            if(pointerOffsetX + (pointerBox.width + 20) > (userselectwidth)) pointerOffsetX = (userselectwidth) - (pointerBox.width  + 20);
                            view.pointerOffsetX = pointerOffsetX + 'px';
                        });
                        if(box.left < 150 || widthTotal < (userselectwidth / 2)) {
                            posx = 5;
                        } else {
                            posx = widthTotal - userselectwidth - 5;
                        }
                    }
                    var pointerDirection = 'top';
                    if(heightTotal - (box.top + box.height + offsety) > userselectheight) {
                        posy = (box.top + box.height + offsety);
                    } else {
                        if(heightTotal < userselectheight || box.top - offsetyBottom - userselectheight < 0) {
                            posy = 5;
                            pointerDirection = 'hide';
                        } else {
                            posy = box.top - offsetyBottom - userselectheight;
                            pointerDirection = 'bottom';
                        }
                    }
                    view.posx = posx;
                    view.posy = posy;
                    view.pointerDirection = pointerDirection;
                    view.$forceUpdate();
                });
            },
            ChangeDate(newDate){
                    if(this.rawData.filter(d => moment.unix(d.dt).date() === newDate.date()).length === 0) return;
                    this.date = newDate;
                    this.date.locale('de');

                    this.InitData();
            },
            Init(options){
                $(this.$el).find('.grid .amount:not(.selection)').css({opacity: 0});
                var view = this;
                view.$el.removeEventListener('mousemove', this.TrackMouse);
                this.saleNew = '0';
                this.saleNewFromHour = '00';
                this.saleNewFromMinutes = '00';
                this.saleNewToHour = '00';
                this.saleNewToMinutes = '15';
                this.itemsFiltered = [];
                this.dailyBars = [];
                this.income = '€ -';
                if(options.elRelative){
                    this.elRelative = options.elRelative
                    this.Reposition();
                }
                if(options.data){
                    this.rawData = options.data;
                }
                if(options.date){
                        this.date = options.date;
                        this.date.minutes(0);
                        this.date.locale('de');
                        this.loadStoreSales()
                        .then(response => {
                            view.rawData = response.data;
                            view.rawData.forEach(d => {
                                d.date = moment(d.from, 'YYYY-MM-DDTHH:mm');
                                d.fromDate = moment(d.from, "YYYY-MM-DDTHH:mm");
                                d.toDate= moment(d.to, "YYYY-MM-DDTHH:mm");
                            });
                            view.InitData(false);
                        }).catch(function (error) {
                            console.log(error)
                        })
                    }
                view.$el.addEventListener('mousemove', this.TrackMouse);
                this.toggled = true;
            },
            InitData(isPlanned){
                var view = this;
                this.dailyBars = [];
                this.itemsFiltered = [];
                    view.rawData.sort((a,b) => {
                        return (parseInt(a.date.format('x')) < parseInt(b.date.format('x'))) ? -1 : 1;
                    });
                    var averageTotal = 0;
                    view.rawData.forEach(d => {
                        averageTotal += isPlanned ? (d.planned ? d.amount : 0) : (!d.planned ? d.amount :0);
                    });
                    view.income = '€ ' + (averageTotal * .01 )+ '-';
                    averageTotal = 0;
                    view.rawData.forEach(d => {
                        averageTotal += d.amount;
                    });
                    var barDivisions = 24;
                    view.gridPixelRatio = (averageTotal * .01) / $('.income-popup .grid').height();
                    view.averageIncomeRatio = view.gridPixelRatio;
                    //averageTotal = averageTotal / barDivisions;

                    var items = view.rawData.filter(d => isPlanned == d.planned);
                    var totalHour = 0;

                    items.forEach(d => {
                        totalHour += d.amount
                    });

                    for(var i = 0; i < items.length; i++){
                        (function(item){

                            var classes = [];
                            var length = view.CalculateLength(100 * (totalHour / averageTotal));
                            length = length + '%';
                            if (totalHour < averageTotal * .3) classes.push('red');
                            else if(totalHour < averageTotal) classes.push('orange');
                            else if (totalHour > averageTotal * .5) classes.push('green');
                            var income = '€ ';
                            income += (item.amount * .01);
                            income += '-';
                            var color = !isPlanned ? classes[0] : 'gray';
                            var itemTemp = {label: income, saleData: item, income: (item.amount * .01), color: color, fromDate: moment(item.from, "YYYY-MM-DDTHH:mm"), toDate: moment(item.to, "YYYY-MM-DDTHH:mm")};
                            view.itemsFiltered.push(itemTemp);
                        })(items[i]);
                    }
                    for(var x = 0; x < barDivisions; x++){

                        (function(hour){
                            var hourItems = view.rawData.filter(d => d.date.hours() === hour && !d.planned);
                            totalHour = 0;

                            hourItems.forEach(d => {
                                totalHour += d.amount
                            });

                            var classes = [];
                            var length = view.CalculateLength(100 * (totalHour / averageTotal));
                            length = length + '%';
                            if (totalHour < averageTotal * .3) classes.push('red');
                            else if(totalHour < averageTotal) classes.push('orange');
                            else if (totalHour > averageTotal * .5) classes.push('green');
                            var income = '€ ';
                            income += (totalHour * .01);
                            income += '-';
                            var color = classes[0];
                            var item = {planned: false, label: income , income: (totalHour * .01), color: color, date: view.date.clone().hours(hour)};

                            //if(!isPlanned)
                            {

                                view.dailyBars.push({classes: classes, income: (totalHour * .01), entry: item, length: length});
                            }

                            var hourItemsPlanned = view.rawData.filter(d => d.date.hours() === hour && d.planned);
                            totalHour = 0;

                            hourItemsPlanned.forEach(d => {
                                totalHour += d.amount
                            });

                            var length = view.CalculateLength(100 * (totalHour / averageTotal));
                            length = length + '%';
                            income = '€ ';
                            income += (totalHour * .01);
                            income += '-';
                            item = {planned: true, label: income, income: (totalHour * .01), color: 'gray', date: view.date.clone().hours(hour)};
                            //if(isPlanned)
                            {
                                view.dailyBars.push({classes: 'gray', income: (totalHour * .01), entry: item, length: length});
                            }
                        })(x)
                    }
                    for(var x in 24){

                    }
                    view.RefreshListInputs();
            },
            RefreshListInputs(){
                var view = this;
                requestAnimationFrame(function(){
                    $(view.$el).find('.entry input').each(function(i,e){
                        $(this).css('width', (10 + ($(this).val().length * 9)) + 'px');
                    });
                });
            },
            CreateStoreSale: function(sale){
                let view = this;
                let url = '/api/sec/storesales';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/storesales');

                let payload = {
                  amount: Math.floor(sale.amount),
                  currency: 'EUR',
                  from: sale.fromDate.format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
                  to: sale.toDate.format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
                  planned: sale.planned,
                  itemCount: sale.itemCount,
                  guestCount: 0,
                  description: sale.description,
                }



                this.axios({
                    method: 'post',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    response.data.data.fromDate = moment(response.data.data.from, 'YYYY-MM-DDTHH:mm');
                    response.data.data.date = response.data.data.fromDate.clone();
                    response.data.data.toDate = moment(response.data.data.to, 'YYYY-MM-DDTHH:mm');
                    view.rawData.push(response.data.data);
                    view.InitData(view.isPlanned);

                    window.roster.RefreshStoreSales();

                }).catch(function (error) {
                    console.log(error)
                })

            },
            EditStoreSale: function(sale){
                let view = this;
                let url = '/api/sec/storesales';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/storesales');

                let payload = {
                  id: sale.id,
                  updateFields:["amount", "currency", "from", "to", "planned", "itemCount", "description"],
                  amount: Math.floor(sale.amount),
                  currency: sale.currency,
                  from: sale.fromDate.format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
                  to: sale.toDate.format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
                  planned: sale.planned,
                  itemCount: sale.itemCount,
                  description: sale.description,
                }



                this.axios({
                    method: 'put',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    view.InitData(view.isPlanned);
                    window.roster.RefreshStoreSales();
                }).catch(function (error) {
                    console.log(error)
                })

            },
            DeleteSale: function(sale){
                let view = this;
                let url = '/api/sec/storesales';

                url = this.$helpers.appendParam("id", sale.id, url, '/api/sec/storesales');
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/storesales');


                this.axios({
                    method: 'delete',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                }).then(response => {
                    view.rawData = view.rawData.filter(s => s !== sale);
                    view.InitData(view.isPlanned);
                    window.roster.RefreshStoreSales();
                }).catch(function (error) {
                    console.log(error)
                })

            },

            loadStoreSales : function() {

              let url = '/api/sec/storesales';
              url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/storesales');

              url = this.$helpers.appendParam("from", this.date.clone().hours(0).format('YYYY-MM-DD') + 'T00:00Z', url, '/api/sec/storesales');
              url = this.$helpers.appendParam("to", this.date.clone().hours(0).add(1, 'day').format('YYYY-MM-DD') + 'T00:00Z', url, '/api/sec/storesales');

              return this.axios({
                method: 'get',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url
              })


            },

        },
        mounted() {
            $('body').append(this.$el);
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .income-popup{
        position:fixed;
        display:inline-block;
        height: 600px;
        width: 400px;
        border-radius: 5px;
        display:none;
        z-index: 1000;
        background: white;
        box-shadow: 4px 4px 5px 3px rgba(0,0,0,0.2);
        padding: 40px;
    }
    .income-popup.daily{
        height: 720px;
    }


     .background {
        position: fixed;
        height: 100vh;
        width: 100vw;
        left: 0;
        right: 0;
        z-index: -1;
        top: 0;
    }




    .header{
    }
    .header .label{
        box-shadow: inset 0 -1px 0 0px #ebebeb;
        font-size: 30px;

    }

    .fa-stack.cancel{
        cursor: pointer;
        position: absolute;
        top: 6px;
        right: 5px;
        font-size: 10px;
        transform: scale(.8);
    }
    .fa-stack.cancel .fa-circle{
    }
    .fa-stack.cancel .fa-times{
        font-size: 13px;
        transform: translateY(3px);
    }

    .weather-popup > .label{
        color: #cccccc;
        font-size: 11px;
        font-weight: 500;
        position: absolute;
        margin-top: -10px;
    }
    .weather-popup > .label.second{

        margin-top: 5px;
    }


    .label{
        background: white;
    }

    .entry .label{

        font-weight: 200;
    }
    .entry > .label{
        padding: 0 5px;
    }
    .entry{
        width: 100%;
        text-align: center;
        display: table;
        position: relative;
    }

    .entry.header{
        box-shadow: none;
        float: none;
        margin-top: 15px;
    }

    .entry.header .fa-stack{

    }

    .entry.header .label{
        box-shadow: none;
        color: #404040;
        float: none;
        font-size: 14px;
        font-family: DistrictProLight;
        letter-spacing: 0.2px;
        margin-left: -6px;
    }

    .entry.header .label.bold{
        font-weight: 700;
        font-family: DistrictProBold;
        letter-spacing: 1.2px;
        margin-left: -5px;
    }

    .entry.icon{
    }
    .entry.icon .picture{
        height: 80px;
        margin-top: -40px;
    }
    .entry.icon .label{
        font-size: 60px;
        font-family: DistrictProLight;
        color: #808080;
        margin: 7px 0px 10px 5px;
        letter-spacing: 0px;
        font-weight: 200;
    }

    .entry.variation{
    margin-top: 5px;
    letter-spacing: -0.2px;
    }

    .entry.timeframe{
        margin-top: 5px;
        letter-spacing: 0.6px;
    }

    .entry.timeframe .label{

        font-size: 10px;
    transform: translateY(-1px);
    }

    .entry.hourly{
    padding-top: 13px;

    }
    .entry.hourly .slot{
        width: 24px;
        margin: 0 3.5px;
        display: inline-block;
    }
    .entry.hourly .slot > *{
        float: left;
    }

    .entry.hourly .slot .hour{

    }
    .entry.hourly .slot .super{
        font-size: 8px;
        transform: translate(1px, -2px);
    }
    .entry.hourly .slot .picture{
        height: 17px;
    margin: 3px 0 10px;

    }
    .entry.hourly .slot .temp{

    margin-top: 4px;
    }
    .entry.hourly .slot .rain{
        color: #08a1e4;
        font-size: 9px;

    font-size: 9px;
    height: 10px;
    width: 100%;
    }

    .entry.nav{
        margin: 12px 0;
    }
    .entry.nav .fa-stack{
        transform: scale(0.45);
    }

    .entry.nav .left{
        left: -25px;
        right: 0;
        top: 1px;
        bottom: 0;
        margin:auto;
        background: white;
        width: 75px;
        cursor: pointer;
    }
    .entry.nav .right{
        right: -25px;
        left: 0;
        top: 1px;
        bottom: 0;
        margin:auto;
        background: white;
        width: 75px;
        cursor: pointer;
    }
    .entry.nav .fa-angle-right, .entry.nav .fa-angle-left{
        pointer-events:none;
    }

    .entry.info{
        margin-top: 25px;
        position: absolute;
        bottom: 55px;
        width: 50%;
    }

    .entry.info .label{
        font-family: DistrictProLight;
        width: 100%;
    letter-spacing: 0.3px;
    margin-left: 7px;
        color: #cccccc;
        font-size: 8px;
        white-space: nowrap;
        font-weight: 500;
        display: block;
        margin-bottom: 2px;
    background: none;
    }

    .entry.location .label, .entry.variation .label, .entry.hourly .label.hour, .entry.hourly .label.temp, .entry.nav .label {
        font-size: 11px;
        color: #808080;
    }

    .left{
        position:absolute;
        margin: 0;
        top: 0px;
        transform: scale(0.7);
        left: 0;
        cursor:pointer;
    }
    .right{
        position:absolute;
        margin: 0;
        top: 0px;
        transform: scale(0.7);
        right: 0;
        cursor:pointer;
    }

    .line-through{
    top: 2px;
        bottom: 0;
        margin: auto;
        width: 100%;
        height: 1px;
        background: #c1c1c1;
        position: absolute;

        z-index: -1;
    }

    .divider{
        width: 100%;
        margin: 15px 0;
        border-bottom: 1px solid #e5e5e5;
    }

    .pointer{
        position: absolute;
        right: 0;
        left: 0;
        margin: auto;
        width: 0;
    }

    .pointer:before{
        content:'';
        position: absolute;
        top: 1px;
        left: -13px;
        z-index: -1;
        filter: blur(5px);
    }

    .pointer:after{
        content:'';
        position: absolute;
        left: -20px;
        background: white;
        width: 40px;
        height: 20px;
        z-index: -1;
    }

    .pointer.top{
        top: -15px;
        border-left: 15px solid transparent;
        border-right: 15px solid transparent;
        border-bottom: 15px solid white;
    }
    .pointer.top:before{
        border-left: 15px solid transparent;
        border-right: 15px solid transparent;
        border-bottom: 15px solid rgba(0,0,0,.2);
    }
    .pointer.top:after{
        top: 15px;
    }
    .pointer.bottom{
        bottom: -15px;
        border-left: 15px solid transparent;
        border-right: 15px solid transparent;
        border-top: 15px solid white;
    }
    .pointer.bottom:before{
        border-left: 15px solid transparent;
        border-right: 15px solid transparent;
        border-top: 15px solid rgba(0,0,0,.2);
        top: initial;
        bottom: 1px;
    }
    .pointer.bottom:after{
        bottom: 15px;
    }

    .pointer.hide{
        display: none;
    }

    .circle{
        border-radius: 100px;
    }

    .circle .miniature{
        position: absolute;
        right: 0;
        left: 0;
        width: 15px;
        height: 15px;
        margin: auto;
        bottom: -20px
    }
    .circle .label{

        position: absolute;
        right: 0;
        left: 0;
        top: 0;
        bottom: 0;
        color: white;
    }

    .red{
        background: #e51c50;
    }

    .orange{
        background: #e86d1d;
    }

    .green{
        background: #6c8d25;
    }
    .empty{
        background: #e5e5e5;
    }

    .circle.top-left{
        position:absolute;
        width: 50%;
        height: 50%;
        top: 0;
        left: 0;
         border-radius: 100px 0 0 0;
    }
    .circle.top-right{
        position:absolute;
        width: 50%;
        height: 50%;
        top: 0;
        right: 0;
         border-radius: 0 100px 0 0;
    }
    .circle.bottom-left{
        position:absolute;
        width: 50%;
        height: 50%;
        bottom: 0;
        left: 0;
         border-radius: 0 0 0 100px;
    }
    .circle.bottom-right{
        position:absolute;
        width: 50%;
        height: 50%;
        bottom: 0;
        right: 0;
        border-radius: 0 0 100px 0;
    }

    .hourly > .circle{
        position:relative;
        height: 50px;
        width: 50px;
        margin: 0 10px;
        display: inline-block;
    }
    .hourly > .circle .label{
        background: none;
        font-size: 10px;
        color: white;
        text-align: center;
        width: 100%;
        margin-top: 10px;
        height: 15px;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
    }
    .daily > .circle{
        position:relative;
        height: 200px;
        width: 200px;
        margin: 40px 10px 10px;
        display: inline-block;
    }
    .daily > .circle .label{
        background: none;
        font-size: 15px;
        color: #cccccc;
        text-align: center;
        width: 100%;
        margin-top: 10px;
        height: 15px;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
    }
    .daily  .circle.top-left{
        box-shadow: inset -4px -4px 0px -2px white;
    }
    .daily  .circle.top-right{
        box-shadow: inset 4px -4px 0px -2px white;
    }
    .daily  .circle.bottom-right{
        box-shadow: inset 4px 4px 0px -2px white;
    }
    .daily  .circle.bottom-left{
        box-shadow: inset -4px 4px 0px -2px white;
    }
    .daily  .circle.top-left .label{
    top: -60%;
    bottom: 0;
    left: -140%;
    right: 0;
    }
    .daily  .circle.top-right .label{
    top: -60%;
    bottom: 0;
    left: 0;
    right: -140%;
    }
    .daily  .circle.bottom-right .label{
        top: 0;
        bottom: -50%;
        left: 0;
        right: -140%;
    }
    .daily  .circle.bottom-left .label{
        top: 0;
        bottom: -50%;
        left: -140%;
        right: 0;
    }

    .entry.daily, .entry.hourly{
        padding: 10px 0;
    }

    .scrollbar-container{
        position: relative;
        height: 220px;
        top: 0;
        margin-top: 15px;
    }

    .scrollbar-container .entry{
        cursor: pointer;
        padding: 3px 5px;
        transition: .2s;
        text-align: left;
        border-radius: 100px 0 0 100px;
    }

    .scrollbar-container .entry .circle{
        width: 16px;
        height: 16px;
        transform: translateY(1px);
        display: inline-block;
    }


    .scrollbar-container .entry .label{
        background: none;
        font-size: 15px;
        transform: translateY(-3px);
    }
    .scrollbar-container .entry .timeframe{
        margin-right: 25px;
        font-family: DistrictProBook;
    }

    .scrollbar-container .entry:nth-child(even){
        background: #e5e5e5;
    }

    .nightmode .scrollbar-container .entry:nth-child(even){
        background: var(--bg);
    }

    .scrollbar-container .entry.border-red{
        background: rgba(155, 0, 0, .3);
    }

    .scrollbar-container .entry.border-red:nth-child(even){
        background: rgba(155, 0, 0, .5);
    }


    .scrollbar-container .entry.border-green{
        background: rgba(0, 180, 0, .3)
    }

    .scrollbar-container .entry.border-green:nth-child(even){
        background: rgba(0, 180, 0, .5)
    }


    .scrollbar-container .entry:hover, .entry.selected{
        background: #6d8d23 !important;
    }

    .scrollbar-container .entry:hover .label, .entry.selected .label{
        color: white;
    }

    .scrollbar-container .entry:hover .circle{
        box-shadow: inset 0 0 0 2px white;
    }
    .scrollbar-container .entry *{
            pointer-events: none;
    }

    .income-popup > .button{
        position: absolute;
    bottom: 50px;
    right: 50px;
    width: 80px;
    height: 30px;
    }
    .income-popup > .button > .label{
        position: absolute;
        background: none;
        margin: auto;
        top: -5px;
        bottom: 0;
        left: 0;
        right: 0;
        transform: none;
        height: 15px;
        text-align: center;
        font-size: 12px;
    }

    .entry.income-list{

        padding: 5px 10px;
    }

    .entry.daily{
        padding: 15px;
    }

    .grid{
        height: 160px;
        box-shadow: inset 1px -1px 0 0px black;
        overflow: hidden;
    }

    .grid .line{
    border-bottom: 1px solid #ccc;
    margin-bottom: 2.4%;
    }

    .gray{
        background: #ccc;
    }

    .grid .bar{
        display: inline-block;
        float: left;
        -webkit-transform: translateY(-100%);
        transform: translateY(-100%)translateX(12px);
        border-radius: 10px 10px 0 0;
        width: 1.95%;
        min-height: 1%;
    }
    .grid .bar .handle{
        opacity: 0;
        -webkit-transition: .2s;
        transition: .2s;
        /* border-bottom: 2px solid #ccc; */
        cursor: pointer;
        position: absolute;
        top: -5px;
        width: 300%;
        left: -100%;
        height: 10px;
        font-size: 30px;
        line-height: 0%;
        color: #808080;
    }
    .grid .bar:hover .handle{
        opacity: 1;
        display: inline-block;
    }
    .grid .bar.gray .handle{
        /*display: none;*/
    }
    .grid .label.bottom{
        position: absolute;
        font-size: 10px;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
    }
    .grid .label.left{
        position: absolute;
        font-size: 10px;
        left: -13px;
        background: none;
        top: 0;
        bottom: 0;
        margin: auto;
        height: 20px;
        transform: rotate(270deg);
    }

    .amount{
        position: fixed;
        margin: auto;
        height: 30px;
        display: inline-block;
        background: white;
        box-shadow: 4px 4px 5px 3px rgba(0,0,0,0.2);
        pointer-events: none;
        width: fit-content;
        padding: 5px;
        border-radius: 5px;
        transform: translate(-50%, -125%);
        opacity: 0;
    }

    .entry > input{
        box-shadow: none !important;
        display: inline !important;
        pointer-events: initial !important;
        width: 20px;
    }

    .entry > input.timeframe{
        width: 18px !important;
        display: inline-block !important;
        margin: 0 !important;
        padding: 0;
    }
    .entry > input.timeframe:nth-child(2){
        margin-left: 5px !important;
    }
    .entry > input.timeframe:nth-child(8){
    margin-right: 29px !important;
    }
    .entry > .hour{
        display: inline-block !important;
        margin: 0 !important;
        padding: 0;
        width: 4px !important;
    }
    .entry > .divider{
        width: 5px !important;
        display: inline-block !important;
        border:none;
        padding: 0;
        margin: 0 3px 0 4px !important;
    }

    .scrollbar-container .entry .fa-stack{
        font-size: 7px;
        position: absolute;
        right: 5px;
        top: 7px;
        pointer-events: initial !important;
        cursor: pointer;
    }
    .scrollbar-container .entry:not(.input) .fa-stack{
        transition: .2s;
        opacity: 0;
    }
    .scrollbar-container .entry:not(.input):hover .fa-stack{
        opacity: 1;
    }
    .scrollbar-container .entry .fa-stack .fa-circle{
    }
    .scrollbar-container .entry .fa-stack .fa-plus,.entry .fa-stack .fa-times{
        transform: scale(.8);
    }

    .amount.selection{
        pointer-events: initial;
        padding: 0;
        overflow: hidden;
        height: initial;
        opacity: 1;
        z-index: 2;
    }

    .amount.selection .label{
        padding: 5px;
        font-size: 15px;
        margin: 0;
        color: black;
        letter-spacing: initial;
        cursor: pointer;
        display: block;


    }
    .amount.selection .label:hover{
        background: #6c8d25;
        color: white;
    }

    .nightmode .pointer:after{
        background: var(--sub-menu);
    }

    .nightmode .pointer.top{
        border-bottom: 15px solid var(--sub-menu);
    }
    .nightmode .pointer.bottom{
        border-top: 15px solid var(--sub-menu);
    }


    .nightmode .left, .nightmode .right{
        background: var(--sub-menu) !important;
    }


    .nightmode .income-popup{
        background: var(--sub-menu);
    }



    .nightmode .label{
        background: var(--sub-menu);
        color: var(--contrast-4) !important;
    }


</style>
